import { createSlice } from "@reduxjs/toolkit";

const darkModeSlice = createSlice({
  name: "darkMode",
  initialState: {
    value: false,
  },
  reducers: {
    setDarkMode: (state, action) => {
      state.value = action.payload;
    },
  },
});
export const { setDarkMode } = darkModeSlice.actions;
export default darkModeSlice.reducer;
